// src/components/About.js
import React from "react";
import "./About.css"; // Import the CSS file

function About() {
  return (
    <>
      <header className="header">
        <h1 className="header-title">About Us</h1>
      </header>
      <div className="about-container">
        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            At AgentSamur.ai, we're on a mission to transform how individuals
            and businesses handle their daily tasks through AI-powered
            automation with the precision and discipline inspired by samurai
            tradition.
          </p>
        </div>
        <div className="about-section">
          <h2>Our Story</h2>
          <p>
            Founded in 2024, AgentSamur.ai was born from the vision that AI
            should work as your dedicated agent, handling research,
            organization, and analysis with unwavering precision. Our team
            combines expertise in artificial intelligence, data science,
            cybersecurity and user experience design to create an AI assistant
            that truly understands your needs.
          </p>
        </div>
        <div className="about-section">
          <h2>Our Approach</h2>
          <p>We believe in AI that serves with:</p>
          <ul>
            <li>
              <strong>Precision:</strong> Every task is handled with meticulous
              attention to detail
            </li>
            <li>
              <strong>Honor:</strong> We uphold the highest standards of data
              privacy and ethical AI use
            </li>
            <li>
              <strong>Discipline:</strong> Consistent, reliable performance you
              can count on
            </li>
            <li>
              <strong>Mastery:</strong> Continuous improvement to perfect our
              craft
            </li>
          </ul>
        </div>
        <div className="about-section">
          <h2>The Team</h2>
          <p>
            Our diverse team brings together backgrounds in AI research,
            software engineering, and business operations. We're united by our
            passion for creating technology that enhances human capability
            rather than replacing it.
          </p>
        </div>
      </div>
    </>
  );
}

export default About;
